import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../../store/actions/profileActions';
import '../../../assets/css/style.css';
import Chip from '@material-ui/core/Chip/Chip';

const RadioChip = ({ name, chipStyles, type }) => {
    const profile = useSelector(state => state.profile.profile);
    const preferenceFilters = useSelector(state => state.profile.preferenceFilters);
    const dispatch = useDispatch();
    
    const handleChange = (name) => {
        if (type === 'gender') {
            if (profile.gender !== name) {
                dispatch(action.collectProfileData({...profile, [type]: name}));
            }
        }
        else if (type === 'preferenceFilters') {
            if (preferenceFilters.campus !== name || preferenceFilters.campus === '') {
                dispatch(action.preferenceFilterUpdate({...preferenceFilters, campus: name}));
            }
        }
        else {
            if (profile.virtue[type] !== name) {
                dispatch(action.collectProfileData({...profile, virtue: {...profile.virtue, [type]: name}}));
            }
        }
    }

    useEffect(() => {
        if (preferenceFilters === null) {
            dispatch(action.preferenceFilterUpdate({...preferenceFilters, campus:'Everyone'}));
        }
    }, []);

    return (
        <Chip key={name} variant="outlined" style={chipStyles} label={name} clickable={true} onClick={() => handleChange(name)} />
    );
};

export default RadioChip;